const validate = values => {
  const errors = {};

  if (!values.dates || !values.dates.startDate || !values.dates.endDate) {
    errors.dates = 'Dates are required';
  }

  return errors;
};

export default validate;
